import { NgModule } from '@angular/core';

import { OutsideClickDirective } from './outside-click-handler.directive';
import { PreventNegativeNumber } from './prevent-negative-number.directive';
import { RepeatHtmlElementTimesDirective } from './repeat-html-element-times.directive';
import { ImageLoaderDirective } from './image-loader.directive';
import { ScrollIntoViewDirective } from './scrollIntoView.directive';
import { TriggerClickOnEnterDirective } from './keyboard-accessible-anchor.directive';
import { KeydownClickDirective } from './keydown-accessibility-event.directive';

const directives = [
  PreventNegativeNumber,
  OutsideClickDirective,
  RepeatHtmlElementTimesDirective,
  ImageLoaderDirective,
  ScrollIntoViewDirective,
];

@NgModule({
  declarations: directives,
  imports: [TriggerClickOnEnterDirective, KeydownClickDirective],
  exports: [...directives, TriggerClickOnEnterDirective, KeydownClickDirective],
})
export class DirectivesModule {}
